// extracted by mini-css-extract-plugin
export default {"buyButton":"BuyButton_buyButton__wuVfk","buyPrice":"BuyButton_buyPrice__R-L+P","highlight":"BuyButton_highlight__-7JuK","shine":"BuyButton_shine__raa9K"};